ixModuleRouting("impactx.ruleset", {
    "/rulesetlist": {
        template: "<ixa-ruleset-list></ixa-ruleset-list>",
        process: "ListRuleSet",
        workspace: "admin",
    },
    "/ruleset/:id": {
        template: "<ixa-ruleset></ixa-ruleset>",
        templateUrl: "modules/ruleset/templates/ruleset.html",
        controller: "RuleSetCtrl",
        controllerAs: "ruleSetCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/rulerequestlist/:RULESETId": {
        template: "<ixa-rulerequest-list></ixa-rulerequest-list>",
        templateUrl: "modules/ruleset/templates/rulesrequestlist.tmpl.html",
        controller: "RuleRequestListCtrl",
        controllerAs: "ruleRequestListCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/ruledemandlist/:RULESETId": {
        template: "<ixa-ruledemand-list></ixa-ruledemand-list>",
        templateUrl: "modules/ruleset/templates/rulesdemandlist.tmpl.html",
        controller: "RuleDemandListCtrl",
        controllerAs: "ruleDemandListCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/ruleinvoicelist/:RULESETId": {
        template: "<ixa-ruleinvoice-list></ixa-ruleinvoice-list>",
        templateUrl: "modules/ruleset/templates/rulesinvoicelist.tmpl.html",
        controller: "RuleInvoiceListCtrl",
        controllerAs: "ruleInvoiceListCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/ruleuserlist/:type/:ATPId": {
        template: "<ixa-ruleuser-list></ixa-ruleuser-list>",
        templateUrl: "modules/ruleset/templates/ruleuserlist.tmpl.html",
        controller: "RuleUserListCtrl",
        controllerAs: "ruleUserListCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/ruleuser/:ATEId/:ATPId?/:refTable?": {
        template: "<ixa-ruleuser></ixa-ruleuser>",
        templateUrl: "modules/ruleset/templates/ruleuser.tmpl.html",
        controller: "RuleUserCtrl",
        controllerAs: "ruleUserCtrl",
        process: "EditRuleUser",
        workspace: "admin",
    },
    "/ruleuserinvoice/:ATEId/:ATPId?": {
        template: "<ixa-ruleuser-invoice></ixa-ruleuser-invoice>",
        templateUrl: "modules/ruleset/templates/ruleuser.tmpl.html",
        controller: "RuleUserInvoiceCtrl",
        controllerAs: "ruleUserCtrl",
        process: "EditRuleUser",
        workspace: "admin",
    },
    "/ruleuserminamount/:ATEId/:ATPId?": {
        template: "<ixa-ruleuser-minamount></ixa-ruleuser-minamount>",
        templateUrl: "modules/ruleset/templates/ruleuser.tmpl.html",
        controller: "RuleUserMinAmountCtrl",
        controllerAs: "ruleUserMinAmountCtrl",
        process: "EditRuleUser",
        workspace: "admin",
    },
    "/ruleusergroup/:ATPId": {
        template: "<ixa-rule-user-group></ixa-rule-user-group>",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/rulebasket/:id/:ruleSetId/:ruleType": {
        template: "<ixa-rulebasket></ixa-rulebasket>",
        templateUrl: "modules/ruleset/templates/rule.html",
        controller: "RuleBasketCtrl",
        controllerAs: "ruleCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/ruleaccounting/:id/:ruleSetId/:ruleType": {
        template: "<ixa-ruleaccounting></ixa-ruleaccounting>",
        templateUrl: "modules/ruleset/templates/rule.html",
        controller: "RuleAccountingCtrl",
        controllerAs: "ruleCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/ruleproduct/:id/:ruleSetId/:ruleType": {
        template: "<ixa-ruleproduct></ixa-ruleproduct>",
        templateUrl: "modules/ruleset/templates/rule.html",
        controller: "RuleProductCtrl",
        controllerAs: "ruleCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/rulebudget/:id/:ruleSetId/:ruleType": {
        template: "<ixa-rulebudget></ixa-rulebudget>",
        templateUrl: "modules/ruleset/templates/rule.html",
        controller: "RuleBudgetCtrl",
        controllerAs: "ruleCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/ruleproductattribute/:id/:ruleSetId/:ruleType": {
        template: "<ixa-ruleproductattribute></ixa-ruleproductattribute>",
        templateUrl: "modules/ruleset/templates/rule.html",
        controller: "RuleProductAttributeCtrl",
        controllerAs: "ruleCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/ruleminamount/:id/:ruleSetId/:ruleType": {
        template: "<ixa-ruleminamount></ixa-ruleminamount>",
        templateUrl: "modules/ruleset/templates/rule.html",
        controller: "RuleMinAmountCtrl",
        controllerAs: "ruleCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/rulesystem/:id/:ruleSetId/:ruleType": {
        template: "<ixa-rulesystem></ixa-rulesystem>",
        templateUrl: "modules/ruleset/templates/rulesystem.html",
        controller: "RuleSystemCtrl",
        controllerAs: "ruleCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
    "/ruleinvoice/:id/:ruleSetId/:ruleType": {
        template: "<ixa-ruleinvoice></ixa-ruleinvoice>",
        templateUrl: "modules/ruleset/templates/rule.html",
        controller: "RuleInvoiceCtrl",
        controllerAs: "ruleCtrl",
        process: "EditRuleSet",
        workspace: "admin",
    },
});
